export class DateHelper {
  public utcDate?: Date;

  constructor(utcDate?: string) {
    try {
      this.utcDate = utcDate ? parseToValidDate(utcDate) : undefined;
    } catch(error) {
      this.utcDate = undefined;
      console.error(error)
    }
  }

  /**
   * Formats the stored UTC date to the application's date format (DD-MM-YYYY).
   * @returns A formatted date string if `utcDate` is defined; otherwise, returns '-'.
   */
  public toAppFormat(): string {
    try {
      return this.utcDate
      ? this.utcDate.toLocaleDateString('nl', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : '-';
    } catch (error) {
      console.error(error + 'asdasdasd')
      return 'Invalid date'
    }
  }

  /**
   * Converts a given date string to an ISO string in UTC.
   * @param date - A date string to convert to ISO format.
   * @returns The ISO string representation of the date in UTC.
   */
  public toISOStringInUTC(date: string): string {
    try {
      const parsedDate = parseToValidDate(date);
      const utcDate = new Date(
        Date.UTC(
          parsedDate.getFullYear(),
          parsedDate.getMonth(),
          parsedDate.getDate(),
          parsedDate.getHours(),
          parsedDate.getMinutes(),
          parsedDate.getSeconds(),
          parsedDate.getMilliseconds()
        )
      );
      return utcDate.toISOString();
    } catch(error) {
      console.error(error)
      return ''
    }
  }
}

function parseToValidDate(input: string): Date {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`Invalid date: "${input}"`);
  }
  return d;
}

export const isPastDate = (date: string | Date | null | undefined, treatTodayAsPast: boolean = false): boolean => {
  if (!date) return false;

  const dateObject = new Date(date);
  const today = new Date();
  dateObject.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return treatTodayAsPast ? dateObject <= today : dateObject < today;
};

